import { render, staticRenderFns } from "./serviceRecordItem.vue?vue&type=template&id=7a743c37"
import script from "./serviceRecordItem.vue?vue&type=script&lang=js"
export * from "./serviceRecordItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports